import { Component, ChangeDetectionStrategy } from '@angular/core';

import { RouterModule } from '@angular/router';
import { GalaxyCardComponent } from '@app/components/ui/galaxy-card/galaxy-card.component';
import { GalaxyButtonDirective } from '@app/directives/galaxy-button.directive';
import { GalaxyRippleDirective } from '@app/directives/galaxy-ripple.directive';

@Component({
  selector: 'app-cta-section',
  imports: [
    RouterModule,
    GalaxyCardComponent,
    GalaxyButtonDirective,
    GalaxyRippleDirective,
  ],
  templateUrl: './cta-section.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./cta-section.component.css'],
})
export class CtaSectionComponent {}
